import {
  REQUEST_SERVICE_LIMITS,
  RECEIVE_SERVICE_LIMITS,
  RECEIVE_SERVICE_LIMITS_ERROR,
} from 'ondemand/actions/serviceLimits';

// Rider limits + usage keyed by service_id: {[serviceId]: {isFetching, limits, error}}.
export default function serviceLimits(state = {}, action) {
  switch (action.type) {
    case REQUEST_SERVICE_LIMITS:
      return Object.assign({}, state, {
        [action.serviceId]: Object.assign({}, state[action.serviceId], {isFetching: true}),
      });
    case RECEIVE_SERVICE_LIMITS:
      return Object.assign({}, state, {
        [action.serviceId]: {isFetching: false, limits: action.limits, error: false},
      });
    case RECEIVE_SERVICE_LIMITS_ERROR:
      return Object.assign({}, state, {
        [action.serviceId]: {isFetching: false, limits: null, error: true},
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/ondemand/reducers/serviceLimits.js